import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { hasSessionEvents } from "@/shared/domain/orgs";
import { useOrgEventModel } from "@/shared/domain/orgs/hooks";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";
import { eventQueryKeys } from "./eventQueryKeys";

export function useEventTags(orgId: string): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();
  const includeSessionEvents = hasSessionEvents(useOrgEventModel(orgId));

  return useQuery({
    queryKey: [...eventQueryKeys.orgTags(orgId), includeSessionEvents],
    queryFn: ({ signal }) => {
      // Callers needing truncation info call the service directly.
      return events
        .getTagsForOrg(
          {},
          {
            abortSignal: signal,
            resourceOwnerId: orgId,
            includeSessionEvents,
          },
        )
        .then((page) => page.items);
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
  });
}
